import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling past hero (~800px)
      if (window.scrollY > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-339">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 w-full z-50 bg-brand-bg/80 backdrop-blur-lg border-t border-brand-border h-[72px] px-4 md:hidden flex items-center justify-between" data-id="element-340">
          <div className="flex flex-col" data-id="element-341">
            <span className="text-brand-red line-through text-xs font-bold" data-id="element-342">
              $505
            </span>
            <span className="text-brand-gold font-display text-2xl font-bold leading-none" data-id="element-343">
              $9.63
            </span>
          </div>

          <a href="https://pay.hotmart.com/X105898119V" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-6 h-[48px] rounded-xl bg-gradient-to-r from-brand-cyan to-brand-purple text-white font-bold text-sm shadow-[0_0_15px_rgba(0,212,170,0.3)] active:scale-95 transition-transform" data-id="element-344">
            ACCESO AHORA →
          </a>
        </motion.div>}
    </AnimatePresence>;
}